<script>

    import {Lottie} from 'lottie-svelte'
    /* import bullet from '../public/timecontrol_bullet_highlight.json' */ /* import blitz from '../public/timecontrol_blitz_highlight.json' */

    import "carbon-components-svelte/css/g90.css"
    import {Tooltip} from 'carbon-components-svelte'
    /* import rapid from '../public/timecontrol_rapid_highlight.json' */
    import {sessionData} from '../stores'
    import {PLAYER_STATE} from "../chess-console-app/ChessConsoleAppState.js"
    import {launchSumsub} from '../sumsub'
    import Stake from '../components/Stake.svelte'
    import Looking from '../components/Looking.svelte'
    import StakeModal from '../components/StakeModal.svelte'
    import Game from './Game.svelte'
    import {isUserRegistered, updateBalance} from '../userdata'
    import {replace, querystring} from 'svelte-spa-router'
    import {onMount} from 'svelte'
    import PlayButton from '../components/PlayButton.svelte'
    import {signInWithCredential} from 'firebase/auth'
    import {fade, slide, fly} from 'svelte/transition'
    import {ChessConsoleApp, createAppAndSendGameRequest} from "../chess-console-app/ChessConsoleApp.js"

    let selected = true
    // let selectedCard = null
    let expl = false
    export let params = {}
    let paymentTrigger = false
    let sumtoken = ''
    let currentStake
    let winToggle = false
    let showModal = false


    function answerRequest() {
        /* $sessionData.cardLocked = true */
        createAppAndSendGameRequest($sessionData.user.uid, $sessionData.user.accessToken, params.tc, Number(params.stake), Number(params.code))
    }

    onMount(() => {
        /* $sessionData.playerState = PLAYER_STATE.linkGame */

        window.onbeforeunload = function () {
            if($sessionData.playerState !== PLAYER_STATE.idle) {
                return "You are currently playing a game. Are you sure you want to leave?" 
            }
        }


        answerRequest()

      })



    /* $: remainingGames = $sessionData.guser.remaining_games || null */

</script>


  <div transition:fly={{y:-20}}  class="select-none bg-space overflow-hidden">
        <Game/>

    </div>

<style>


</style>

